/**
 * http配置
 */
import Vue from 'vue';
import axios from 'axios';
import router from '../../router';
import { showLoading, hideLoading } from './common';

Vue.prototype.$http = axios;

// http请求拦截器
axios.interceptors.request.use(config => {
  showLoading();
  config.url = process.env.API + config.url;
  return config
}, error => {
  hideLoading();
  return Promise.reject(error)
});
// http响应拦截器
axios.interceptors.response.use(data => {
  hideLoading();
  // 登录后长时间未操作，则跳到登陆页
  if (data.data.resultCode === 'relogged') {
    localStorage.clear();
    router.replace({
      path: '/',
      query: {redirect: router.currentRoute.fullPath}
    });
    router.go(0);
  }
  return data;
}, error => {
  hideLoading();
  return Promise.reject(error)
});

export default axios



// WEBPACK FOOTER //
// ./src/components/common/axios.js